import React from 'react';
import SVGIcon from 'lib/images/svg-icon/svg-icon';
import Styled from 'styled';

import checkbox from 'four-nets/icons/svg/icon_radio_disabled.svg';
import checkboxActive from 'four-nets/icons/svg/icon_radio_enabled.svg';
import Badge from 'four-nets/ui-v2/badges/badge/badge';

import defaultStyles from './field-view.scss';

export interface Props {
    name: React.ReactChild;
    selected: boolean;
    pending: boolean;
    onClick: (options: any) => void;
    count?: number | null;
    styles: typeof defaultStyles;
}

class FieldView extends React.Component<Props> {
    render() {
        const { name, count, selected, pending, onClick } = this.props;
        const styles = this.props.styles!;

        const fieldStyles = [styles.field];
        if (selected || pending) {
            fieldStyles.push(styles.selected);
        }

        return (
            <div className={styles.inlineWrapper}>
                <button className={fieldStyles.join(' ')} onClick={onClick}>
                    <SVGIcon style={{ image: styles.icon }} src={selected || pending ? checkboxActive : checkbox} />
                    <div className={styles.name}>{name}</div>
                    {count ? <Badge>{count}</Badge> : null}
                </button>
            </div>
        );
    }
}

export default Styled(defaultStyles)(FieldView);
